import {
  FETCH_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_EDGES,
  FETCH_LATEST_NOTIFICATIONS,
  SET_NOTIFICATIONS_STATE,
} from '../../actions/types';

const INITIAL_STATE = {
  loading: true,
  error: '',
  all: [],
  edges: {},
  latest: [],
};

export default function notificationsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_NOTIFICATIONS_STATE:
      return {
        ...state,
        loading: action.payload.loading,
        error: action.payload.error,
      };
    case FETCH_NOTIFICATIONS:
      return {
        ...state,
        all: action.payload,
      };
    case FETCH_NOTIFICATIONS_EDGES:
      return {
        ...state,
        edges: action.payload,
      };
    case FETCH_LATEST_NOTIFICATIONS:
      return {
        ...state,
        latest: action.payload,
      };
    default:
      return state;
  }
}
